/* Landing Filtro: packs, CTA conectado a Releasit y barra fija que lleva a los packs. Solo se carga en la plantilla product.landing-filtro. */
(function () {
  if (window.__lfBound) return;
  window.__lfBound = true;

  var RSI = [
    '#_rsi-buy-now-button',
    'button._rsi-buy-now-button',
    'button[class*="_rsi-buy-now"]',
    'button[id*="_rsi"]',
    '[id^="_rsi"] button',
    '[class*="_rsi-"] button',
    'button[class*="releasit"]',
    '[class*="releasit"] button'
  ];

  function scope() {
    return document.querySelector('[id^="ProductInformation-"]') || document.querySelector('product-information') || document;
  }

  function isOrderForm(el) {
    var f = el.closest('form');
    return !!(f && f.querySelector('input[type="tel"], input[name*="phone"], input[name*="telefono"]'));
  }

  function findRsi() {
    var root = scope();
    for (var i = 0; i < RSI.length; i++) {
      var list = root.querySelectorAll(RSI[i]);
      for (var j = 0; j < list.length; j++) {
        var el = list[j];
        if (el.closest('.lf') || el.closest('dialog, [role="dialog"], [aria-modal="true"]') || isOrderForm(el)) continue;
        return el;
      }
    }
    return null;
  }

  /* El boton de Releasit ya no se oculta: es el boton de pedido de la pagina (se retiro el boton verde). */
  var hideQueued = false;
  function hideRsi() {
    hideQueued = false;
  }

  function selectVariant(id) {
    if (!id) return;
    var picker = document.querySelector('variant-picker[ref="mainVariantPicker"]') || document.querySelector('variant-picker');
    if (picker) {
      var input = picker.querySelector('input[type="radio"][data-variant-id="' + id + '"]');
      if (input) {
        if (!input.checked) input.click();
      } else {
        var opt = picker.querySelector('option[data-variant-id="' + id + '"]');
        if (opt) {
          var select = opt.closest('select');
          if (select && select.value !== opt.value) {
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (i) {
      if (i.value !== String(id)) {
        i.value = id;
        i.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateHero(card) {
    var hero = document.querySelector('[data-lpp-hero]');
    if (!hero) return;
    var price = hero.querySelector('[data-lpp-price]');
    var compare = hero.querySelector('[data-lpp-compare]');
    var save = hero.querySelector('[data-lpp-save]');
    var saveAmt = hero.querySelector('[data-lpp-save-amt]');
    var cmp = card.getAttribute('data-compare');
    var sv = card.getAttribute('data-save');
    if (price) price.textContent = card.getAttribute('data-price');
    if (compare) { compare.textContent = cmp; compare.hidden = !cmp; }
    if (save) save.hidden = !sv;
    if (saveAmt) saveAmt.textContent = sv;
  }

  /* La barra fija inferior siempre muestra el pack elegido arriba (nombre, precio y texto del boton). */
  function updateSticky(card) {
    var bar = document.querySelector('[data-lf-sticky]');
    if (!bar) return;
    var p = card.getAttribute('data-price');
    var c = card.getAttribute('data-compare');
    var n = card.getAttribute('data-name');
    var btn = bar.querySelector('[data-lf-sticky-btn]');
    var price = bar.querySelector('[data-lf-sticky-price]');
    var cmp = bar.querySelector('[data-lf-sticky-compare]');
    var lab = bar.querySelector('[data-lf-sticky-label]');
    if (btn) {
      btn.setAttribute('data-variant-id', card.getAttribute('data-variant-id'));
      var base = btn.getAttribute('data-label-base');
      if (base) btn.textContent = btn.getAttribute('data-show-price') === 'true' ? base + ' - ' + p : base;
    }
    if (price) price.textContent = p;
    if (cmp) { cmp.textContent = c || ''; cmp.hidden = !c; }
    if (lab && n) lab.textContent = n + ' · Pagas al recibir';
  }

  function selectPack(card) {
    var root = card.closest('[data-lf-buybox]');
    if (!root || card.disabled) return;
    root.querySelectorAll('[data-lf-pack]').forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    selectVariant(card.getAttribute('data-variant-id'));
    updateHero(card);
    updateSticky(card);
  }

  function scrollToEl(el, offset) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* Espacio para que la cabecera fija no tape el titulo "Elige tu pack". */
  function headerOffset() {
    var h = document.querySelector('header-component, #header-group, header');
    var b = h ? Math.max(h.getBoundingClientRect().bottom, 0) : 0;
    return Math.max(b, 70) + 14;
  }

  /* La barra fija lleva al cliente a los packs y resalta el pack elegido. No abre el formulario. */
  function goToPacks() {
    var box = document.querySelector('[data-lf-buybox]');
    if (!box) return;
    scrollToEl(box, headerOffset());
    box.classList.remove('is-glow');
    void box.offsetWidth;
    box.classList.add('is-glow');
    setTimeout(function () { box.classList.remove('is-glow'); }, 1600);
  }

  function openOrder() {
    setTimeout(function () {
      var b = findRsi();
      if (b) { b.click(); return; }
      var target = document.querySelector('[id^="ProductInformation-"] form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (target) scrollToEl(target, 120);
    }, 300);
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-lf-pack]');
    if (card) { selectPack(card); return; }

    if (e.target.closest('[data-lf-cta]')) {
      e.preventDefault();
      var active = document.querySelector('[data-lf-buybox] [data-lf-pack].is-active');
      if (active) selectVariant(active.getAttribute('data-variant-id'));
      openOrder();
      return;
    }

    if (e.target.closest('[data-lf-sticky-btn]')) {
      e.preventDefault();
      goToPacks();
    }
  });

  function initSticky() {
    var bar = document.querySelector('[data-lf-sticky]');
    var box = document.querySelector('[data-lf-buybox]');
    if (!bar || !box || bar.__lf || !('IntersectionObserver' in window)) return;
    bar.__lf = true;
    var btn = bar.querySelector('button');
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }).observe(box);
  }

  function init() {
    var active = document.querySelector('[data-lf-buybox] [data-lf-pack].is-active');
    if (active) selectPack(active);
    initSticky();
    hideRsi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
  document.addEventListener('shopify:section:load', init);

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (hideQueued) return;
      hideQueued = true;
      requestAnimationFrame(hideRsi);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
